<div [ngClass]="{'set-candidate-page-margin': showCard}">
  <mojo-candidate-details-card
    *ngIf="!hideDetails"
    [candidate]="candidate$ | async"
    data-cy="candidate-details-card"
  ></mojo-candidate-details-card>

  <ng-container *ngIf="candidate$ | async as candidate">
    <ng-container *ngIf="cantShowPdf$ | async; else pdf">

      <mojo-candidate-resume-card
        [showCard]="showCard"
        [experiences]="candidate.experiences"
        [overview]="candidate?.overview"
        *ngIf="candidate?.experiences?.length > 0"
        data-cy="candidate-resume-card"
      ></mojo-candidate-resume-card>

      <div
        *ngIf="candidate?.experiences?.length > 0"
        class="line"
      ></div>

      <mojo-candidate-education-card
        [showCard]="showCard"
        [educations]="candidate.educations"
        *ngIf="candidate?.educations?.length > 0"
        data-cy="candidate-education-card"
      ></mojo-candidate-education-card>

      <div
        *ngIf="candidate?.educations?.length > 0"
        class="line"
      ></div>

      <mojo-candidate-certifications-card
        [showCard]="showCard"
        [certifications]="candidate.application.certifications"
        *ngIf="candidate?.application?.certifications?.length > 0"
        data-cy="candidate-certifications-card"
      ></mojo-candidate-certifications-card>

      <div
        *ngIf="candidate?.application?.certifications?.length > 0"
        class="line"
      ></div>

      <mojo-candidate-achievements-card
        [showCard]="showCard"
        [achievements]="candidate.application.achievements"
        *ngIf="candidate?.application?.achievements?.length > 0"
        data-cy="candidate-achievements-card"
      ></mojo-candidate-achievements-card>
      <div
        *ngIf="candidate?.application?.achievements?.length > 0"
        class="line"
      ></div>
    </ng-container>
    <ng-template #pdf>
      <mojo-candidate-pdf-resume-card
        [showCard]="showCard"
        [resumeSrc]="resumeSrc$ | async"
        [resumeId]="resumeId$ | async"
        [resumeTitleHidden]="resumeTitleHidden"
        data-cy="candidate-pdf-resume-card"
      ></mojo-candidate-pdf-resume-card>
    </ng-template>

    <div *ngIf="hardSkills$ | async as skills">
      <mojo-candidate-skills-card
        header="Hard Skills"
        [showCard]="showCard"
        [isNotAnonymized]="isNotAnonymized"
        [fromTalentPool]="fromTalentPool"
        [skills]="skills"
        data-cy="hard-candidate-skills-card"
      ></mojo-candidate-skills-card>
    </div>

    <div
      *ngIf="hardSkills$ | async"
      class="line"
    ></div>

    <div *ngIf="softSkills$ | async as skills">
      <mojo-candidate-skills-card
        header="Soft Skills"
        [showCard]="showCard"
        [isNotAnonymized]="isNotAnonymized"
        [fromTalentPool]="fromTalentPool"
        [skills]="skills"
        data-cy="soft-candidate-skills-card"
      ></mojo-candidate-skills-card>
    </div>
  </ng-container>
</div>
